import { h } from "./createElement";
import { __assign, __extends, __rest } from "tslib";
import React from 'react';
var CHECK_POSITION_INTERVAL = 100;
var PositionChangeDetector = (function (_super) {
    __extends(PositionChangeDetector, _super);
    function PositionChangeDetector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.checkPositionChangeTimer = null;
        _this.displayPosition = null;
        _this.refDom = function (dom) {
            _this.ref.current = dom;
            var domRef = _this.props.domRef;
            if (!domRef) {
                return;
            }
            if (typeof domRef === 'function') {
                domRef(dom);
            }
            else {
                domRef.current = dom;
            }
        };
        _this.checkPositionChange = function () {
            var _a, _b;
            var dom = _this.ref.current;
            if (!dom) {
                return;
            }
            var position = dom.getBoundingClientRect();
            if (_this.displayPosition
                && (Math.abs(_this.displayPosition.left - position.left) > 1
                    || Math.abs(_this.displayPosition.top - position.top) > 1)) {
                (_b = (_a = _this.props).action) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            _this.displayPosition = position;
        };
        return _this;
    }
    ;
    PositionChangeDetector.prototype.componentDidMount = function () {
        if (!this.props.disabled) {
            this.startDetection();
        }
    };
    PositionChangeDetector.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.disabled && !this.props.disabled) {
            this.startDetection();
        }
        if (!prevProps.disabled && this.props.disabled) {
            this.stopDetection();
        }
    };
    PositionChangeDetector.prototype.componentWillUnmount = function () {
        this.stopDetection();
    };
    PositionChangeDetector.prototype.startDetection = function () {
        this.stopDetection();
        this.checkPositionChangeTimer = setInterval(this.checkPositionChange, CHECK_POSITION_INTERVAL);
    };
    PositionChangeDetector.prototype.stopDetection = function () {
        clearInterval(this.checkPositionChangeTimer);
        this.displayPosition = null;
    };
    PositionChangeDetector.prototype.render = function () {
        var _a = this.props, children = _a.children, domRef = _a.domRef, disabled = _a.disabled, action = _a.action, rest = __rest(_a, ["children", "domRef", "disabled", "action"]);
        return (h("div", __assign({}, rest, { ref: this.refDom }), children));
    };
    return PositionChangeDetector;
}(React.Component));
export default PositionChangeDetector;
